import { appsignal } from './appsignal'
import { plugin } from '@appsignal/plugin-window-events'
import $ from 'jquery'
import documentReady from './documentReady.ts'
import updateHeaderBasketSummary from './updateHeaderBasketSummary'
import { trackFacebookAddToCart } from './tracking/facebook/facebook_add_to_cart'
import { resetCustomTubeCuttingBar, submitCustomTubeCuttingBar } from '../metal_store/customTubeCuttingBar'
import { generateDataAndSubmitCuttingToolBar } from '../metal_store/submitCuttingToolBar'

appsignal.use(plugin())

// @param {Array<JQuery.NameValuePair>} serializedInputField
// @param {Object} basketItems
// @param {Array<{name:string, sku:string}>} addedProducts
//
// Given a serialized input field representing a product that has been added or removed
// from the basket, updates basketItems and addedProducts.
//
// basketItems tracks the current items in the user's basket. It is updated to reflect removals
// as well as additions.
//
// addedProducts tracks the products that have been *newly* added to the basket, answering
// the question: 'What has the customer just added to their basket?'.
function trackItem (serializedInputField, basketItems, addedProducts) {
  const el = document.querySelector(`[name="${serializedInputField.name}"]`)
  const productId = el?.dataset.productId
  if (!productId) return
  const name = document.querySelector(`.product-name[data-product-id="${productId}"]`)?.innerText
  const sku = document.querySelector(`meta[itemprop="sku"][data-product-id="${productId}"]`)?.getAttribute('content')
  if (!name || !sku) return
  const { value: quantity } = serializedInputField

  // Don't track if quantity has been set to zero
  if (['', '0'].includes(quantity)) {
    // Update our current page's basket items
    basketItems[productId] = null
  } else {
    // track 'Add to basket' only if item is not already in basket
    if (!basketItems[productId]) {
      // Update our current page's basket items
      basketItems[productId] = { quantity }
      addedProducts.push({ name, sku })
    }
  }
}

function displayDiscountBar (display) {
  const discountBar = document.querySelector('.discount-bar')

  // Check if localStorage is accessible. On some browsers like Safari, disabling
  // all cookies will result in an insecure operation when accessing localStorage.
  let showDiscountBar
  try {
    showDiscountBar = localStorage?.getItem('show-discount-bar')
    if (showDiscountBar === null) { localStorage?.setItem('show-discount-bar', 1); showDiscountBar = 1 }
  } catch {
    return
  }

  if (!discountBar) {
    return
  }

  if (showDiscountBar === '0') {
    discountBar.style.display = 'none'
    return
  }

  discountBar.style.display = display
}

function bindAjaxForm () {
  let $message = $('<div title="Basket Updated" class="basket-update-message success"><strong>Your shopping basket has been updated</strong></div>')
  $message.append('<a href="/basket">View Basket / Checkout</a>').hide()
  displayDiscountBar('none')

  const basketItems = {}

  // Pre-populate basket items
  if (typeof window.basketQuantities !== 'undefined') {
    if (window.basketQuantities.length > 0) {
      displayDiscountBar('block')
    }
    window.basketQuantities.forEach((item) => {
      const [id, quantity] = item
      basketItems[id] = { quantity }
    })
  }

  const $form = $('.add-to-basket-form')

  $form.on('submit', async function (event) {
    event.preventDefault()

    const formFieldData = $form.serializeArray();

    (function beforeBasketSubmit () {
      $('.flash-notice').fadeOut(function afterFlashFadeOut () {
        $(this).remove()
      })

      const addedProducts = []
      formFieldData.forEach((serializedInputField) => {
        trackItem(serializedInputField, basketItems, addedProducts)
      })
      trackFacebookAddToCart(addedProducts)

      $('.basket-update-message').fadeOut(200)

      $form.find("input[type='submit']").hide()
      $form.find("input[type='submit']").before('<div class="loader">Updating</div>')
    })()

    function basketSubmitted (response) {
      updateHeaderBasketSummary(response.basket)
      if (response.basket.total_quantity > 0) {
        displayDiscountBar('block')
      }

      if (response.basket.exceeded_limit) {
        $message = $('<div title="Basket Full" class="basket-update-message failure"><strong>Your shopping basket is full</strong></div>')
        $message.append('<a href="/basket">View Basket / Checkout</a>')
          .hide()
      }
      $message.appendTo($form.find('.sticky-button')).fadeIn()
      $message.appendTo($form.find('.non-sticky-button')).fadeIn()

      resetCustomTubeCuttingBar()
    }

    await submitCustomTubeCuttingBar()
    await generateDataAndSubmitCuttingToolBar()

    fetch($form.attr('action'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: $form.serialize(),
      credentials: 'same-origin'
    }).then(
      response => response.json()
    ).then(
      data => basketSubmitted(data)
    ).catch(
      (e) => window.alert(`Your basket could not be updated - please try again: ${e}`)
    ).finally(
      function () {
        $form.find('.loader').remove()
        $form.find("input[type='submit']:not(.hidden)").show()
      }
    )
  })
}

function prepareUI () {
  bindAjaxForm()

  $('#category-list-container').on('click', '.category-list a.dialog', function dialogLinkClicked (e) {
    e.preventDefault()

    const url = $(this).attr('href')
    const $overlay = $('<div />', { class: 'overlay' }).appendTo('body')
    const $popup = $('<div />', { id: 'productPopup', class: 'ui-dialog' }).appendTo($overlay)
    const $close = $('<button />', { class: 'close', text: '×', title: 'Close' }).appendTo($popup)
    const $dialog = $('<div />', { class: 'dialog-scroll' }).appendTo($popup)
    $('html').addClass('noscroll')
    $close.on('click', () => {
      $overlay.remove()
      $('html').removeClass('noscroll')
    })

    $dialog.load(url, function dialogLoaded () {
      bindAjaxForm($)

      const $heading = $dialog.find('.page-title')
      const $uspsContainer = $dialog.find('.home-usps-container')
      const $timerMessage = $dialog.find('.timer-message')

      $heading.remove()
      $uspsContainer.remove()
      $timerMessage.remove()

      $dialog.find('td.submit .button').addClass('hidden')

      const buttons = [
        {
          text: 'Close',
          click: function closeClicked () {
            $(this).dialog('close')
          }
        }
      ]

      if ($(this).find('form').length) {
        buttons[1] = {
          text: 'Add to Basket',
          click: function buttonClicked () {
            $(this).find('form').trigger('submit')
          }
        }
      }
    })
  })
}

documentReady(prepareUI)
